import { config } from './config';
import axios from "axios";

export const naplesNoActivatedSearchTermService = {
    get,
    config
};

function get(params){

    let axiosConfig = {}
    let endpoint;

    // Append to request.
    axiosConfig['params'] = params;

    endpoint = '/api/proxy/naples/domain/no-activated-search-term/?page_size=1&lock_minutes=1440';

    endpoint += '&nocache=' + Date.now();

    return new Promise((resolve, reject) => {
      axios
        .get(`${config.apiUrl}${endpoint}`, axiosConfig)
        .then(response => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
}
